"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTab = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _Button = require("../../Button");
var _ButtonTabModule = _interopRequireDefault(require("./ButtonTab.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ButtonTab = exports.ButtonTab = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    iconName,
    iconType = 'regular',
    size,
    onButtonTabSelect,
    id,
    selectedButtonTabId,
    disabled,
    isLeftCurved,
    isRightCurved,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(_Button.Button, _extends({}, props, {
    disabled: disabled,
    size: size,
    type: "tertiary",
    ref: ref,
    classNames: {
      wrapper: (0, _classify.default)(_ButtonTabModule.default.buttonTabWrapper, {
        [_ButtonTabModule.default.mediumButtonTab]: size === 'medium',
        [_ButtonTabModule.default.smallButtonTab]: size === 'small',
        [_ButtonTabModule.default.onlyIcon]: iconName && !children,
        [_ButtonTabModule.default.isSelected]: id === selectedButtonTabId,
        [_ButtonTabModule.default.disabled]: disabled,
        [_ButtonTabModule.default.leftCurved]: isLeftCurved,
        [_ButtonTabModule.default.rightCurved]: isRightCurved
      }, classNames?.wrapper),
      icon: _ButtonTabModule.default.icon
    },
    iconLeftName: iconName,
    iconLeftType: iconType,
    onClick: e => onButtonTabSelect && onButtonTabSelect(id, e)
  }), children);
});